/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PersonalAuthNewsletterDTO {
    affi?: string;
    captcha?: string;
    datastore?: string;
    email?: string;
    env?: string;
    landingpage?: string;
    newsletter?: string;
    partner?: string;
}
